import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, pipe } from 'rxjs';
import { UrlTree } from '@angular/router';
import { map } from 'rxjs/operators';
import { USER_ROLE } from 'src/app/shared/enum/role.enum';
import { UserInfo } from 'src/app/shared/models/user-info.model';
import { AuthService } from '../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'src/app/core/services/message.service';
import {} from 'src/app/shared/utils/utils-global';

@Injectable({
  providedIn: 'root',
})

export class CentralGuard implements CanActivate, CanActivateChild 
{
	public readonly validationQueryParameter:string = "state";
	private VALID_OBFUSCATED_VALUE:string="";
	private readonly VALID_CLEARTEXT_VALUE:string = "valid";

	constructor(public msg:MessageService
		, private router: Router
		, private authService: AuthService
		, private translateService: TranslateService
	) {
		console.debugEx( "CentralGuard.CTOR");
		// state value is just Base64 encoded but not encrypted. Any change in the obfuscating strategy must be implemented below
		this.VALID_OBFUSCATED_VALUE = btoa( this.VALID_CLEARTEXT_VALUE);
	}

	public canActivate( next: ActivatedRouteSnapshot, state: RouterStateSnapshot, ) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
	{
		return this.validateApp( next, state);
	}

	public canActivateChild( next: ActivatedRouteSnapshot, state: RouterStateSnapshot, ) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
	{
		return this.validateApp( next, state);
	}

	public validateApp( next: ActivatedRouteSnapshot, state: RouterStateSnapshot, ) : Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
	{
		let requestedUrl: string = state.url;
		console.debugEx ( `CentralGuard.validateApp: state.url = ${state.url}` );
		let p:string = next.queryParams[this.validationQueryParameter];
		console.debugEx ( `CentralGuard.validateApp: queryParams = ${p}` );
		
		// in case the requested route does not match any of teh defined routes => page not found
		if( next.routeConfig?.path == "**")
		{
			this.msg.set( 'ERRORS.PAGE_NOT_FOUND' );
			let redirectTo = this.router.createUrlTree( ['/messages'], { queryParams: {...next.queryParams}});
			console.debugEx ( `CentralGuard.validateApp: will return RedirectTo "${redirectTo.toString()}" - msgid = "${this.msg.message}" )  "` );
			return redirectTo;
		}
		return true;

		// VALID_OBFUSCATED_VALUE is computed in the CentralGuard constructor
		if( p && p == this.VALID_OBFUSCATED_VALUE)
		{
			console.debugEx ( `CentralGuard.validateApp: queryParams = ${state.url} route is validated.` );
			return true;
		}

		console.debugEx ( `CentralGuard.validateApp: queryParams = ${state.url} route is not validated.` );
		this.msg.set( 'ERRORS.INVALID_DEVICE' );
		let redirectTo = this.router.createUrlTree( ['/messages']);
		console.debugEx ( `CentralGuard.validateApp: will return RedirectTo "${redirectTo.toString()}" - msgid = "${this.msg.message}" )  "` );
		return redirectTo;
	}
	

}
